<app-dialog-container>
  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content class="dialogContent">
    <!-- MOTIVO -->
    <mat-form-field class="input" appearance="outline">
      <mat-label>MOTIVO</mat-label>
      <input
        [disabled]="typeCes !== typeCesEnum.EDIT"
        cdkFocusInitial
        matInput
        class="uppercase"
        [(ngModel)]="element.cancellationReason"
      />
    </mat-form-field>

    <!-- DATA -->
    <mat-form-field
      class="input"
      appearance="outline"
      *ngIf="typeCes === typeCesEnum.SHOW"
    >
      <mat-label>DATA E HORA</mat-label>
      <input
        [disabled]="typeCes == typeCesEnum.SHOW"
        cdkFocusInitial
        matInput
        class="uppercase"
        [ngModel]="element.canceledAt | date : 'dd/MM/yyyy HH:mm'"
      />
    </mat-form-field>

    <!-- USUARIO QUE CANCELOU -->
    <mat-form-field
      class="input"
      appearance="outline"
      *ngIf="typeCes === typeCesEnum.SHOW"
    >
      <mat-label>USUÁRIO QUE CANCELOU</mat-label>
      <input
        [disabled]="typeCes == typeCesEnum.SHOW"
        cdkFocusInitial
        matInput
        class="uppercase"
        [ngModel]="element.canceledBy?.firstName?.toUpperCase()"
      />
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end" *ngIf="typeCes === typeCesEnum.EDIT">
    <button mat-button mat-dialog-close (click)="clickNo()">SAIR</button>
    <button mat-button cdkFocusInitial (click)="clickOk()">CONTINUAR</button>
  </div>

  <div mat-dialog-actions align="end" *ngIf="typeCes === typeCesEnum.SHOW">
    <button mat-button mat-dialog-close (click)="clickNo()">OK</button>
  </div>
</app-dialog-container>
